import linkServices from '../../services/link';
import Link from '../../model/link';

export const state = {
    links: [],
    link: {},
}

export const mutations = {
    setLink(state, link) {
        state.link = link
    },
    setLinks(state, links) {
        state.links = links
    },
    addLink(state, link) {
        state.links = [link, ...state.links]
    },
}

export const getters = {
    getLink(state) {
        return new Link(state.link);
    },
    getLinks(state) {
        return state.links.map((p)=>new Link(p))
    },
}

export const actions = {
    get({commit}, id){
        return linkServices.get(id)
        .then((response)=>{
            commit('setLink', response.data.data)
            return response
        })
    },
    getAll({commit}, data = {}){
        return linkServices.getAll(data)
        .then((response)=>{
            commit('setLinks', response.data.data)
            return response
        })
    },
    add({commit}, link){
        return linkServices.add(link)
        .then((response)=>{
            commit('addLink', response.data.data)
            return response
        })
    },
    edit({commit, state}, {id, link}){
        return linkServices.edit(id, link)
        .then((response)=>{
            let links = state.links
            links[links.findIndex((x)=>x.id == id)] = response.data.data
            commit('setLinks', links)
            return response
        })
    },
    delete({commit}, id){
        return linkServices.delete(id)
        .then((response)=>{
            commit('setLinks', (state.links.filter((x)=>x.id != id)))
            return response
        })
    },
}